import { AxiosInstance } from 'axios'
import { Result } from '../../../Shared/Protocol/protocol-result'

export interface TAuthLoginDTO {
  username: string
  password: string
}
export interface TAuthLoginResponse {
  sessionToken: string
  refreshToken: string
  username: string
  permissions: string[]
  permissionsScreens: string[]
  resetPassword: boolean
}

export interface TAuthRefreshTokenResponse {
  token: string
  refreshToken: string
}

export class AuthenticationApiRemoteService {
  constructor (private readonly service: AxiosInstance) {}

  public login = async (
    data: TAuthLoginDTO
  ): Promise<Result<TAuthLoginResponse>> => {
    try {
      const result = await this.service.post('/login', data)

      return Result.ok(result.data)
    } catch (error: any) {
      throw error?.response?.data
    }
  }

  public refreshToken = async (
    refreshToken: string
  ): Promise<Result<TAuthRefreshTokenResponse>> => {
    try {
      const result = await this.service.post('/refresh-token', { refreshToken })

      return Result.ok(result.data)
    } catch (error: any) {
      throw error?.response?.data
    }
  }
}
